import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { modules } from 'module/model/module.fragments';
import { ModuleSort } from 'module/model/module.sort';
import { ModuleType } from 'module/model/module.type';

import { ApiQuery } from '../../../../common/model/api.query';
import { ModuleOutput } from '../model/module.output';

export interface FetchOrganizationModulesByCriteriaInput {
	readonly name?: string;
	readonly phasesId?: string[];
	readonly moduleType?: ModuleType;
	readonly organizationId: string;
}

export interface FetchOrganizationModulesByCriteriaParams {
	input: FetchOrganizationModulesByCriteriaInput;
}

@Injectable({ providedIn: 'root' })
export class FetchOrganizationModulesByCriteriaApiQuery extends ApiQuery<
	ModuleOutput[],
	FetchOrganizationModulesByCriteriaParams
> {
	client = 'content';
	document = gql`
		query FetchOrganizationModulesByCriteria(
			$input: FetchOrganizationModulesByCriteriaInput!
		) {
			fetchOrganizationModulesByCriteria(input: $input) {
				...Modules
			}
		}
		${modules}
	`;
	method = 'fetchOrganizationModulesByCriteria';
}
